import { Component, inject } from '@angular/core';
import { PersonPerWorkFrontService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PersonPerWorkFrontCreateDto,
  PersonPerWorkFrontDto,
  PersonPerWorkFrontExcelDownloadDto,
  PersonPerWorkFrontUpdateDto,
} from '../proxy/controlling/dtos/person-per-work-front';
import { PERSONPERWORKFRONT_CONFIG, PERSONPERWORKFRONT_FIELDS } from './person-per-work-front.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-person-per-work-front',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PersonPerWorkFrontService, ConfirmationService],
  templateUrl: './person-per-work-front.html',
  styleUrl: './person-per-work-front.scss',
})
export class PersonPerWorkFront extends BaseHierarchicalCrudComponent<
  PersonPerWorkFrontDto,
  PersonPerWorkFrontCreateDto,
  PersonPerWorkFrontUpdateDto,
  PersonPerWorkFrontExcelDownloadDto
> {
  service = inject(PersonPerWorkFrontService);
  config = PERSONPERWORKFRONT_CONFIG;
  fields = PERSONPERWORKFRONT_FIELDS;

  protected prepareUpdateDto(data: any, selected: PersonPerWorkFrontDto): PersonPerWorkFrontUpdateDto {
    return {
      workFrontId: data.workFrontId,
      personId: data.personId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PersonPerWorkFront';
  }
}
